<template>
    <div class="select_currency">
        <button class="select_currency_button" @click="toggleDropdown">
            <span>
                <span v-if="selectedCountry">{{getCountryByISO(selectedCountry)?.flag}} {{getCountryByISO(selectedCountry)?.name}}</span>
                <span v-else>{{text('auth.register.country')}}</span>
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none">
                <path d="M5.82199 6.81355C5.42431 7.38756 4.57569 7.38756 4.178 6.81355L0.891225 2.06949C0.431745 1.40629 0.9064 0.5 1.71322 0.5L8.28678 0.500001C9.0936 0.500001 9.56825 1.40629 9.10877 2.0695L5.82199 6.81355Z" fill="#090A0A"/>
            </svg>
        </button>
        <div v-if="list_active" class="currency_lists">
            <input 
                type="text" 
                v-model="searchQuery" 
                class="country_search" 
                :placeholder="text('select_exchange.search_placeholder')"
                @click.stop
                ref="searchInput"
            />
            <div class="countries_container">
                <button 
                    :class="`currency_list ${selectedCountry == country.iso ? 'currency_list_active' : ''}`" 
                    @click="selectCountry(country.iso)" 
                    v-for="(country, idx) in filteredCountries" 
                    :key="idx"
                >
                    <span>{{country.flag}} {{country.name}}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="#C7FF24" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { allowedCountries } from '@/data/countries.js'

export default {
    name: "SelectCountry",
    props: {
        modelValue: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue'],
    data () {
        return {
            selectedCountry: this.modelValue,
            countryList: allowedCountries,
            list_active: false,
            searchQuery: '',
        }
    },
    watch: {
        modelValue(newValue) {
            this.selectedCountry = newValue;
        }
    },
    methods: {
        selectCountry (countryISO) {
            this.selectedCountry = countryISO;
            this.list_active = false;
            this.searchQuery = '';
            this.$emit('update:modelValue', countryISO);
        },
        getCountryByISO(iso) {
            return this.countryList.find(country => country.iso === iso);
        },
        toggleDropdown() {
            this.list_active = !this.list_active;
            if (this.list_active) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            } else {
                this.searchQuery = '';
            }
        }
    },
    computed: {
        filteredCountries() {
            return this.countryList.filter(country => country.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        }
    }
}
</script>

<style>

</style> 